import { Outlet } from '@tanstack/react-router';

export const EmptyTemplate = () => (
  <div
    key='empty-layout'
    className='w-full h-full flex flex-row items-center fade-in overflow-scroll'>
    <Outlet />
  </div>
);
